import { VContainer } from 'vuetify/lib/components/VGrid';
import { VLayout } from 'vuetify/lib/components/VGrid';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(VLayout,[_c(VContainer,{staticClass:"hidden-sm-and-down"},[_c('v80d3010pc')],1),_c(VContainer,{staticClass:"hidden-md-and-up"},[_c('v80d3010m')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }